import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { LeadDialog } from "@/components/landing/LeadDialog";

const LeadCtx = createContext(null);

export const useLead = () => useContext(LeadCtx);

export const LeadProvider = ({ children }) => {
  const [dialog, setDialog] = useState({ open: false, service: "auto" });

  const openForm = useCallback((service = "auto") => {
    setDialog({ open: true, service });
  }, []);

  const setOpen = useCallback((open) => {
    setDialog((d) => ({ ...d, open }));
  }, []);

  const value = useMemo(() => ({ openForm }), [openForm]);

  return (
    <LeadCtx.Provider value={value}>
      {children}
      <LeadDialog open={dialog.open} onOpenChange={setOpen} service={dialog.service} />
    </LeadCtx.Provider>
  );
};
